import IconComponent from "icons/IconComponent";

import ArrowRightIcon from "./arrow-right.svg";

export default (ArrowRightIcon as any) as IconComponent;
